'use client';

import type { RefObject } from 'react';
import { useEffect } from 'react';

interface UsePublishElementHeightOptions {
  enabled?: boolean;
  extraOffset?: number;
}

/**
 * 하단 크롬(탭바·CTA·플로팅 배너)이 자신의 높이를 루트 CSS 변수로 publish해
 * 채널톡 같은 floating 요소가 그 위로 자연스럽게 뜨도록 한다. 마운트/리사이즈에
 * 맞춰 동기화하고 언마운트 시 변수를 제거한다.
 */
export const usePublishElementHeight = (
  ref: RefObject<HTMLElement | null>,
  cssVariable: string,
  { enabled = true, extraOffset = 0 }: UsePublishElementHeightOptions = {},
) => {
  useEffect(() => {
    const root = document.documentElement;
    const element = ref.current;

    if (!enabled || !element) {
      root.style.removeProperty(cssVariable);

      return;
    }

    const publish = () => {
      root.style.setProperty(
        cssVariable,
        `${element.offsetHeight + extraOffset}px`,
      );
    };

    publish();

    const observer = new ResizeObserver(publish);
    observer.observe(element);

    return () => {
      observer.disconnect();
      root.style.removeProperty(cssVariable);
    };
  }, [ref, cssVariable, enabled, extraOffset]);
};
